import { useEffect, useState } from "react";
import Card from "components/card";
import CrudPanel from "views/admin/management/components/CrudPanel";
import { roleService } from "services/roleService";
import { useAppLanguage } from "hooks/useAppLanguage";

export default function RolesPage() {
  const language = useAppLanguage();
  const isArabic = language === "ar";
  const [permissions, setPermissions] = useState<any[]>([]);

  useEffect(() => {
    const run = async () => {
      try {
        const result = await roleService.listPermissions();
        const list = Array.isArray(result?.data) ? result.data : result || [];
        setPermissions(Array.isArray(list) ? list : []);
      } catch {
        setPermissions([]);
      }
    };
    run();
  }, []);

  return (
    <div className="mt-4 grid gap-5">
      <Card extra="w-full p-6">
        <h3 className="mb-2 text-lg font-bold text-navy-700 dark:text-white">
          {isArabic ? "الصلاحيات" : "Permissions"}
        </h3>
        <p className="mb-3 text-sm text-gray-500">
          {isArabic
            ? "الصلاحيات المتاحة القادمة من `/mcp/permissions`."
            : "Available permissions returned from `/mcp/permissions`."}
        </p>
        <div className="flex flex-wrap gap-2">
          {permissions.length ? (
            permissions.map((permission, idx) => (
              <span
                key={permission?.id ?? idx}
                className="rounded-full bg-gray-100 px-3 py-1 text-xs text-gray-700 dark:bg-navy-700 dark:text-white"
              >
                {permission?.name ||
                  permission?.slug ||
                  (isArabic ? `صلاحية ${idx + 1}` : `Permission ${idx + 1}`)}
              </span>
            ))
          ) : (
            <span className="text-sm text-gray-500">
              {isArabic ? "لا توجد صلاحيات محمّلة." : "No permissions loaded."}
            </span>
          )}
        </div>
      </Card>

      <CrudPanel
        title={isArabic ? "الأدوار" : "Roles"}
        description={
          isArabic ? "إدارة الأدوار وربطها بالصلاحيات." : "Manage roles and permissions."
        }
        list={roleService.listRoles}
        show={roleService.showRole}
        create={roleService.createRole}
        update={roleService.updateRole}
        remove={roleService.deleteRole}
        previewKeys={["id", "name", "slug", "created_at"]}
        createTemplate={{
          name: "",
          permissions: [],
        }}
        disableAdvancedFilters
      />
    </div>
  );
}

